module.exports = __webpack_public_path__ + "img/LighterThan5kg.7649cf18.svg";